<template>
  <fragment>
    <div class="end-card-spacer" :style="{ order: clusterIndex * 3}">
      &nbsp;
    </div>

    <div class="end-card" :class="{'has-appeared': hasFocused}" :style="{ order: clusterIndex * 3 + 1}" :data-index="`${clusterIndex}`" :data-node="clusterSlug(clusterIndex)">

      <!-- <div class="inner-section" :class="getCurrentReadStateClass">
        <div class="state-group" :class="getCurrentReadStateClass">
          <div class="marker">
            <global-svg class="icon" :type="getReadStateIcon(readState.code)" :color="getReadStateColor(readState.code)" height="11px"/>
          </div>
          <span class="state-name">{{ getReadStateName(readState) }}</span>
          <span class="state-message">You’ve caught up with this story.</span>
        </div>
      </div> -->

      <div class="inner-section state-go-pro" v-if="!isPro && isSignedIn">
        <div class="state-group state-go-pro">
          <div class="marker">
            <global-svg class="icon" type="about" color="#FFF" height="11px"/>
          </div>
          <span class="state-name">{{ card.message }}</span>
          <span class="state-message">Get the full timeline of events leading up to this story</span>
        </div>
        <div class="inner-cta state-go-pro">
          <div class="inner-content">
            <span class="callout">Become a Pro user from £2.99</span><br/>
            Help us change news as we know it.
          </div>
          <button @click="goPro">Go Pro</button>
        </div>
      </div>

      <div class="inner-section state-sign-up" v-if="!isSignedIn">
        <div class="state-group state-sign-up">
          <div class="marker">
            <global-svg class="icon" type="about" color="black" height="11px"/>
          </div>
          <span class="state-name">Take control of your news diet.</span>
          <span class="state-message">Culturally and politically balanced news from around the world.</span>
        </div>
        <div class="inner-cta state-sign-up">
          <div class="inner-content">
            <span class="callout">Join Nourish today.</span><br/>
            No ads, no trackers, no nonsense.
          </div>
          <button @click="showSignUp">Join Now</button>
        </div>
      </div>

    </div>

  </fragment>
</template>

<script>
  import utils from '@assets/js/utils.js';
  import layout from '@assets/js/layout.js';
  import story from '@assets/js/news/story-utils.js';

  import { Fragment } from 'vue-fragment';

  export default {
    mixins: [story, utils, layout],
    components: {
      Fragment,
    },
    props: {
      slug: String,
      node: String,
      cluster: Object,
      clusterIndex: Number,
      focus: Boolean,
      type: String
    },
    data: () => {
      return {
        hasFocused: false,
      };
    },


    computed: {
      isPro () {
        return Boolean(this.$store.getters.isPro);
      },

      isSignedIn() {
        return this.$store.getters.isLoggedIn; 
      },
      
      card() {
        // console.log('Cluster:', this.cluster)
        return this.cluster?.card || {};
      },

      getNextStory() {
        return this.$dataEngine.nextStory;
      },

      readState() {
        return this.$store.getters.readState(this.slug) || {};
      },

      getCurrentReadStateClass() {
        if (this.readState.code) {
          return `state-${this.readState.code}`
        }
        
        return 'state-preview'
      },

      getRemainderReadStateClass() {
        return `state-${this.readState.code}`
      },

      isFocused() {
        return this.clusterSlug(this.clusterIndex) == this.node;
      },
    },

    methods: {
      goPro() {
        this.EventBus.$emit("didSelectSubscribe", {
          didSelect: 'true' 
        });
      },
      showSignUp() {
        this.$store.commit("updateShowModal", 'skip');
      },

      getReadStateColor(code) {
        switch (code) {
          case 'preview': return '#6D7479'
          case 'glanced': return '#6D7479'
          case 'skimmed': return '#6D7479'
          case 'read': return '#14B31F'
          default: return '#6D7479'
        }
      },

      getReadStateIcon(code) {
        // console.log(code)
        if (code) {
          if (code === 'skimmed' || code === 'read') {
            return 'double-tick'
          }

          return 'single-tick'
        }
        return 'single-tick'
      },

      getReadStateName(readState) {
        if (readState.name) {
          return readState.name
        }

        return 'Previewed'
      }
    },

    watch: {
      focus(to) {
        if (to) {
          this.hasFocused = true;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/__2020_v3.scss';

  .end-card {
    .desktop & {
      grid-column: span 1;
    }
    .mobile & {
      // sitting above the "next-up"
      padding-bottom: 122px;
    }

    .context-v5 & {
      .desktop & {
        grid-column: span 2;
      }
    }
  }

  // .end-card-spacer {
  //   .desktop & {
  //     @include sticky-meta;
  //   }
  // }

  // play in styling.. 
  .end-card {
    opacity: 0;
    transition: opacity .3s .6s ease-in-out;
    &.has-appeared {
      opacity: 1;
    }
    // height: 100vh;
  }

  .inner-section {
    display: flex;
    flex-direction: column;
    align-items: center;

    &::before {
      content: '';
      height: 25vh;

      .mobile & {
        height: 50px;
      }

      width: 2px;
      background: $neutral-400;
      margin: 1em auto;
    }

    &.state-read,
    &.state-go-pro {
      &::before {
        background: $green-tone-3;
      }
    }

    &.state-sign-up {
      color: $black-primary !important;
      &::before {
        background: $yellow-tone-3;
      }
    }
  }

  .state-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 1.5em 1em;

    .desktop & {
      border-radius: $el-border-radius;
    }

    .marker {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border: 2px solid $neutral-400;
      border-radius: 50%;
    }

    .state-name {
      @include typo-size-heading;
      color: $neutral-400;
      margin-top: 0.75em;
    }

    .state-message {
      @include typo-size-body-small;
      margin-top: 0.75em;

      .desktop & {
        @include typo-size-body;
        margin-top: 0.5em;
      }
    }

    &.state-read {
      .marker {
        border: 2px solid $green-tone-3;
      }

      .state-name {
        color: $green-tone-3;
      }
    }

    &.state-go-pro {
      background: $green-tone-3;

      .marker {
        border: 2px solid $white-primary;
      }

      .state-name,
      .state-message {
        color: $white-primary;
      }
    }

    &.state-sign-up {
      background: $yellow-tone-3;

      .marker {
        border: 2px solid $yellow-tone-7;
      }

      .state-name {
        color: $yellow-tone-7;
      }
    }
  }

  .inner-cta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2px;
    width: 100%;
    padding: 1em;

    .desktop & {
      border-radius: $el-border-radius;
      margin-top: 5px;
    }

    .inner-content {
      @include typo-size-body-small;
      flex: 1;
      margin: auto 1em auto auto;

      .desktop & {
        @include typo-size-body;
      }

      .callout {
        font-weight: bold
      }
    }

    button {
      @include base-btn;
      background: $white-primary;
    }

    &.state-go-pro {
      background: $green-tone-3;

      .inner-content {
        color: $white-primary;
      }

      button {
        background: $green-tone-4;
        color: $white-primary;
      }
    }

    &.state-sign-up {
      background: $yellow-tone-3;
    }
  }
</style>